const DEFAULT_SUBURB: number[] = [];

export default DEFAULT_SUBURB;
